import { createSelector } from "@reduxjs/toolkit";
import { State } from "../../types";

export const isLoadingVesselsSelector = (state: State) =>
  state.vessel.isLoadingVessels;

export const selectedVesselIdSelector = (state: State) =>
  state.vessel.selectedVesselId;

export const selectedMahSelector = (state: State) => state.vessel.selectedMah;

export const isEpsButtonActiveSelector = (state: State) =>
  state.vessel.isEpsButtonActive;

export const vesselsSelector = (state: State) =>
  state.vessel.vessels
    .filter(({ cd_vessel }) => ["MV29", "XX00", "FF11"].includes(cd_vessel))
    .map((vessel) => ({
      ...vessel,
      city: "Cidade de Campos dos Goytacazes",
      image_url: "/images/fpso.png",
    }));

export const vesselSelector = createSelector(
  vesselsSelector,
  selectedVesselIdSelector,
  (vessels, vesselId) =>
    vessels.find(
      ({ cd_vessel }) => cd_vessel.toLowerCase() === vesselId.toLowerCase(),
    ),
);
